'use strict';

module.exports = {
  __init__: [ 'distributeElements' ],
  distributeElements: [ 'type', require(158) ]
};
